import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FilledButtonComponent, OutlinedButtonComponent } from '@custom-components/general/button';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

export type RemoveGroupMemberMode = 'device' | 'location' | 'partnership';

export interface RemoveGroupMemberDialogData {
  mode: RemoveGroupMemberMode;
  /** Human-readable identifier of the member (LDN, address, partner name, …) shown in the confirmation. */
  label: string;
}

const TITLE_KEYS: Record<RemoveGroupMemberMode, string> = {
  device: 'installationGroups.removeDevice.title',
  location: 'installationGroups.removeLocation.title',
  partnership: 'installationGroups.removePartnership.title',
};

const MESSAGE_KEYS: Record<RemoveGroupMemberMode, string> = {
  device: 'installationGroups.removeDevice.message',
  location: 'installationGroups.removeLocation.message',
  partnership: 'installationGroups.removePartnership.message',
};

@Component({
  selector: 'xemex-remove-group-member-dialog',
  imports: [
    MatIconModule,
    MatDialogModule,
    TranslateModule,
    FilledButtonComponent,
    OutlinedButtonComponent,
    DialogShellComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './remove-group-member-dialog.component.html',
})
export class RemoveGroupMemberDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<RemoveGroupMemberDialogComponent>);
  readonly data = inject<RemoveGroupMemberDialogData>(MAT_DIALOG_DATA);

  readonly titleKey = TITLE_KEYS[this.data.mode];
  readonly messageKey = MESSAGE_KEYS[this.data.mode];

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
